export default __webpack_public_path__ + "static/media/gb.85441430.svg";